export default "__VITE_ASSET__B7Z117$Q__"